<template>
  <div>
    <span
      v-for="info in orderInfo"
      :key="info.label"
    >
      <el-tooltip
        placement="top-start"
        :content="info.label"
        :open-delay="500"
      >
        <el-tag
          :type="info.type"
          effect="plain"
        >
          {{ info.content }}
        </el-tag>
      </el-tooltip>
    </span>
  </div>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { getMap, getMapLabel, getEditLogMap, getLabelText } from '@/utils/i18n'

export default {
  name: 'orders-log',
  props: {
    inputData: {
      type: String,
      default: ''
    },
    tzLocation: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      val: null
    }
  },
  created () {
  },
  computed: {
    orderInfo () {
      let info = []
      let raw = this.inputData
      if (raw) {
        let d = JSON.parse(raw)
        this.convData(d, 'discount')
        d.redeem_status = this.getRedeemStatus(d)
        if ('origin' in d && (
          'no_show_at' in d.origin ||
          'used_time' in d.origin
        )) {
          d.origin.redeem_status = this.getRedeemStatus(d.origin)
        }
        this.addInfo(
          info, d, 'status',
          this.$t('api.optFields.ordersStatus.label'),
          (s) => {
            return this.getStatusLabel(s)
          })
        this.addInfo(
          info, d, 'booking_time',
          this.$t('api.orders.fields.booking_time.label'),
          (s) => {
            return this.$moment.tz(s, this.tzLocation)
              .format('YYYY-MM-DD HH:mm Z')
          })
        this.addInfo(
          info, d, 'discount',
          this.$t('api.orders.fields.yc_discount.label'),
          (s) => {
            return this.$t('api.editLog.fields.orderInfo.ycDiscount', {
              discount: s
            })
          })
        this.addInfo(
          info, d, 'cust_num',
          this.$t('api.orders.fields.cust_num.label'),
          (s) => {
            return this.$t('api.editLog.fields.orderInfo.custNum', {
              custNum: s
            })
          })
        this.addInfo(
          info, d, 'redeem_status',
          this.$t('api.orders.fields.redeem_status.label'),
          (s) => {
            return this.getRedeemStatusLabel(s)
          })
        this.addInfo(
          info, d, 'member_note',
          this.$t('api.orders.fields.member_note.label'),
          (s) => {
            return s
          })
        this.addInfo(
          info, d, 'penalty_type',
          this.$t('api.optFields.penaltyType.label'),
          (s) => {
            return this.getLabelFromEditLogMap('penaltyType', s)
          })
        this.addInfo(
          info, d, 'penalty_skip_payment',
          this.$t('api.optFields.skipPayment.label'),
          (s) => {
            return this.getLabelFromEditLogMap('penaltySkipPayment', s)
          },
          'danger')
      }
      return info
    }
  },
  methods: {
    doCopy,
    getMap,
    getMapLabel,
    getEditLogMap,
    getLabelText,
    addInfo (info, d, field, label, getContent, forceTagType) {
      if (field in d && d[field] !== null && d[field] !== '') {
        info.push({
          label: label,
          content: getContent(d[field]),
          type: this.getTagType(d, field, forceTagType)
        })
      }
    },
    isFieldExists (obj, field) {
      return (obj !== null && typeof obj === 'object' && field in obj)
    },
    convData (d, field) {
      if (this.isFieldExists(d, field) &&
          this.isFieldExists(d[field], field)) {
        d[field] = d[field][field]
      }
    },
    getRedeemStatus (d) {
      return (d.no_show_at) ? 'no_show' : (d.used_time) ? 'redeemed' : 'unredeemed'
    },
    getTagType (d, field, forceTagType) {
      if (forceTagType) {
        return forceTagType
      } else if (this.isUpdated(d, field)) {
        return 'primary'
      }

      return 'info'
    },
    getStatusLabel (s) {
      return this.getMapLabel(this.getMap('status', 'orders'), s)
    },
    getRedeemStatusLabel (s) {
      return this.getLabelText('orders', s)
    },
    getLabelFromEditLogMap (name, s) {
      return this.getMapLabel(this.getEditLogMap()[name], s)
    },
    isUpdated (d, field) {
      if (d.origin && field in d.origin) {
        if (d[field] !== d.origin[field]) {
          if (field === 'booking_time') {
            return !this.$moment(d[field]).isSame(this.$moment(d.origin[field]))
          }
          return true
        }
      }
      if ('displayStatus' in d) {
        switch (field) {
          case 'status':
          case 'redeem_status':
            return true
        }
      }
      return false
    }
  }
}
</script>
